import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { catchError, Observable, of } from 'rxjs';
import {
	AutoRechargeSaveRequest,
	AutoRechargeSettings
} from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

const DISABLED_DEFAULT: AutoRechargeSettings = {
	enabled: false,
	threshold_credits: 0,
	topup_amount_cents: 0,
	disabled_reason: null,
	has_saved_card: false
};

export interface IAutoRechargeService {
	get(): Observable<AutoRechargeSettings>;
	save(request: AutoRechargeSaveRequest): Observable<AutoRechargeSettings>;
}

/**
 * Reads/writes the brand's auto-recharge (auto top-up) settings for
 * Influencer API credits. GET degrades to a disabled default so a failed
 * read never breaks the Credits section of the billing page.
 */
@Injectable({ providedIn: 'root' })
export class AutoRechargeService implements IAutoRechargeService {
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/credits/auto-recharge`;

	constructor(private http: HttpClient) {}

	get(): Observable<AutoRechargeSettings> {
		return this.http
			.get<AutoRechargeSettings>(this.url)
			.pipe(catchError(() => of(DISABLED_DEFAULT)));
	}

	save(request: AutoRechargeSaveRequest): Observable<AutoRechargeSettings> {
		return this.http.put<AutoRechargeSettings>(this.url, request, {
			headers: idempotencyHeaders()
		});
	}
}
